import { useEffect, useState, useMemo, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../redux-store/hooks";
import { getCategoryList, getProductsList } from "../services";
import { setFilteredProducts } from "../redux-store";
import { STATUS } from "../constants";

const useProductSearch = (enabled = true) => {
  const dispatch = useAppDispatch();
  const products = useAppSelector((state) => state.allproducts.data);
  const productStatus = useAppSelector((state) => state.allproducts.status);
  const categories = useAppSelector((state) => state.categories.data);
  const categoryStatus = useAppSelector((state) => state.categories.status);
  const [searchTxt, setSearchTxt] = useState("");
  const [category, setCateory] = useState("");

  // Fetch products list if not already fetched
  useEffect(() => {
    if (!enabled) return;
    if (products.length === 0 && productStatus === STATUS.EMPTY) {
      dispatch(getProductsList());
    }
    if (categories.length === 0 && categoryStatus === STATUS.EMPTY) {
      dispatch(getCategoryList());
    }
  }, [dispatch, enabled, products.length, productStatus, categories.length, categoryStatus]);

  // Memoized filtered products based on searchTxt
  const filteredProducts = useMemo(() => {
    if (!enabled || (!searchTxt && !category)) {
      return products;
    }

    if (!searchTxt && category) {
      return products.filter(
        (product) => product.category.toLowerCase() === category
      );
    }

    const lowerCaseSearchTxt = searchTxt.toLowerCase();
    return products.filter(
      ({ name, category, productCode }) =>
        name.toLowerCase().includes(lowerCaseSearchTxt) ||
        category.toLowerCase().includes(lowerCaseSearchTxt) ||
        productCode.toString().includes(searchTxt)
    );
  }, [products, searchTxt, category, enabled]);

  useEffect(() => {
    if (enabled) {
      dispatch(setFilteredProducts(filteredProducts));
    }
  }, [dispatch, enabled, filteredProducts]);

  // Keep handlers stable so header controls do not force extra child renders.
  const searchTheProduct = useCallback((txt: string) => {
    setSearchTxt(txt);
  }, []);

  const setCategoryTxt = useCallback((txt: string) => {
    setCateory(txt.toLowerCase());
  }, []);

  return {
    filteredProducts,
    searchTxt,
    searchTheProduct,
    categories,
    setCategoryTxt,
  };
};

export { useProductSearch };
